import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';
import { SimpleHeader } from 'components/ui/SimpleHeader';
import loginElbbImg from 'assets/img/2026/login_elbb.png';
import logoPremioBB from 'assets/img/2026/logo_premio.png';
import estrelasElbb from 'assets/img/2026/estrelas_elbb.png';
import './style.scss';
import { ativarModoSimulacao } from "utils/modo-simulacao";

export function LoginElbb() {
  const navigate = useNavigate();
  const { loginWithToken, login } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleIniciarJornada = () => {
    navigate('/home-elbb');
  };

  useEffect(() => {
    async function doLogin(username: string, password: string) {
      try {
        await login({ username, password });
        
        // Aguarda um pouco antes de navegar para garantir que tudo foi salvo
        setTimeout(() => {
          navigate("/home-elbb");
        }, 150);
      } catch (e) {
        console.error('Login failed:', e);
        setLoading(false);
      }
    }

    async function doLoginWithToken(token: string) {
      try {
        await loginWithToken(token);
        
        // Aguarda um pouco antes de navegar
        setTimeout(() => {
          navigate("/home-elbb");
        }, 150);
      } catch (e) {
        console.error('Token login failed:', e);
        setLoading(false);
      }
    }

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const agent = params.get("agent");
    const secret = params.get("secret");
    const tokenItem = params.get("tokenItem");

    if (token) {
      setLoading(true);
      doLoginWithToken(token);
    } else if (agent && secret) {
      setLoading(true);
      doLogin(agent, secret);
    } else if (tokenItem) {
      setLoading(true);
      const decodedToken = atob(tokenItem);
      const tokenParts = decodedToken.split(":");
      const id = tokenParts[0];
      const password = tokenParts[1];

      ativarModoSimulacao();
      doLogin(id, password);
    }
  }, [loginWithToken, login, navigate]);

  return (
    <div id="login-public-wrapper" className="login-theme-2026">
      {/* Container Principal com a nova cor de fundo via SCSS */}
      <div className="relative flex flex-col w-screen h-screen overflow-hidden main-background">
        
        {/* Fundo Estrelas - Controlado via SCSS agora */}
        <div className="absolute inset-0 z-0 stars-container" aria-hidden="true">
          <img
            src={estrelasElbb}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        {/* Header is provided by the app layout; avoid rendering duplicate header here. */}

        {/* Conteúdo Central */}
        <main className="flex flex-1 items-center justify-center px-4 md:px-8 lg:px-12 relative pb-4 content-wrapper">
          
          {/* O Texto "PRÊMIO" ao fundo (Ghost Text) será inserido via CSS no ::before deste container ou do wrapper */}
          
          <div className="flex flex-col items-center justify-center max-w-5xl z-10 w-full login-content">
            <div className="text-center mb-6 space-y-0.5 headings-container">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight">
                <span className="block">A grande jornada com ideias</span>
                <span className="block">transformadoras e inspiradoras começou.</span>
              </h1>
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight mt-1 highlight-text">
                Foi dada a largada ao <span>Prêmio ELBB!</span>
              </p>
            </div>

            <div className="flex justify-center mb-8">
              <button
                onClick={handleIniciarJornada}
                className="btn-iniciar-jornada"
                disabled={loading}
                aria-busy={loading ? "true" : "false"}
              >
                {loading ? 'CARREGANDO...' : 'INICIAR JORNADA!'}
              </button>
            </div>

            <div className="relative flex items-end justify-center images-container">
              <div className="relative z-10">
                <img
                  src={loginElbbImg}
                  alt="Logo Prêmio ELBB"
                  className="login-elbb__illustration"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}